import { computed, ref } from 'vue'

const useWeeklySpendings = () => {
  const totalWeeklySpending = ref(0)
  const isAmountBlur = ref(true)

  // Getters
  const getTotalWeeklySpending = computed(() => totalWeeklySpending.value)
  const getIsAmountBlur = computed(() => isAmountBlur.value)

  // Setters
  const setTotalWeeklySpending = amount => {
    totalWeeklySpending.value = amount
  }

  const setIsAmountBlur = value => {
    isAmountBlur.value = value
  }

  return {
    getTotalWeeklySpending,
    getIsAmountBlur,

    setTotalWeeklySpending,
    setIsAmountBlur,
  }
}

export default useWeeklySpendings
